import React from 'react';
import { Collapse } from 'react-bootstrap';

import HasArray from 'shared/components/parameters/section_panelized/HasArray';
import Panelized from 'shared/components/parameters/section_panelized/Panelized';
import YesPanelized from 'shared/components/parameters/section_panelized/YesPanelized';
import NoPanelized from 'shared/components/parameters/section_panelized/NoPanelized';
import HiddenInput from 'shared/components/HiddenInput';

const SectionPanelized = (props) => {
  const { parameters, groupName } = props;
  const { has_array } = parameters;

  return (
    <div className="array-need">
      <HasArray {...props} />
      <Collapse in={has_array === '1'}>
        <div>
          <div className="array-fields">
            <Panelized {...props} />
            <Collapse in={parameters.is_panelized === '1'}>
              <div className="yes-panelized">
                <YesPanelized {...props} />
              </div>
            </Collapse>
            <Collapse in={parameters.is_panelized === '0'}>
              <div className="no-panelized">
                <NoPanelized {...props} />
              </div>
            </Collapse>
            <HiddenInput
              name="tab_rout"
              value={parameters.tab_rout}
              groupName={groupName} />
            <HiddenInput
              name="scoring"
              value={parameters.scoring}
              groupName={groupName} />
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default SectionPanelized;
